import {actions as ACTION} from "./types";
import {Api, ApiUrl} from "../../services";

const actions = {
  async [ACTION.LOG_FETCH_USER]() {
    return await Api.base.get(ApiUrl.base.eventLog.associatedUsers)
  },

  async [ACTION.LOG_FETCH_EVENT](_, params) {
    return await Api.base.get(ApiUrl.base.eventLog.logs, {params})
  }
};

export default actions;
